import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-reject_26484afd89c95d3b5420859f9fd6895e",
  "use": "ic-reject_26484afd89c95d3b5420859f9fd6895e-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-reject_26484afd89c95d3b5420859f9fd6895e\">\n<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#FBEBEB\" />\n<path d=\"M21.5998 11.5284L20.4718 10.4004L15.9998 14.8724L11.5278 10.4004L10.3998 11.5284L14.8718 16.0004L10.3998 20.4724L11.5278 21.6004L15.9998 17.1284L20.4718 21.6004L21.5998 20.4724L17.1278 16.0004L21.5998 11.5284Z\" fill=\"#C90000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol